module.exports = __webpack_public_path__ + "static/media/monthlySocialMedia.0e7ec335.jpg";